'use client'

import * as React from 'react'
import { Progress as ProgressPrimitive } from 'radix-ui'

import { cn } from '../../lib/utils'

interface ProgressProps extends React.ComponentProps<typeof ProgressPrimitive.Root> {
  progressColor?: string;
  indicatorClassName?: string;
}

function Progress({
  progressColor,
  indicatorClassName,
  className,
  value,
  ...props
}: ProgressProps) {
  return (
    <ProgressPrimitive.Root
      data-slot='progress'
      className={cn(
        'tw:bg-primary/20 tw:relative tw:h-2 tw:w-full tw:overflow-hidden tw:rounded-full',
        className
      )}
      {...props}
    >
      <ProgressPrimitive.Indicator
        data-slot='progress-indicator'
        className={cn('tw:h-full tw:w-full tw:flex-1 tw:transition-all', !progressColor && !indicatorClassName && 'tw:bg-primary/80', indicatorClassName)}
        style={{
          transform: `translateX(-${100 - (value || 0)}%)`,
          ...(progressColor ? { backgroundColor: progressColor } : {}),
        }}
      />
    </ProgressPrimitive.Root>
  )
}

export { Progress }
